import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { Redirect } from 'react-router-dom'

import { loginSuccess } from '../../store/user'
import { GoogleLogin as ReactGoogleLogin } from 'react-google-login'

export const GoogleLogin = () => {
    const [redirect, setRedirect] = useState(false)
    if (redirect) return <Redirect to={'/'} />

    const dispatch = useDispatch()

    const onSuccess = ({ tokenId }) => {
        dispatch(loginSuccess(tokenId))
        setRedirect(true)
    }

    return (
        <ReactGoogleLogin
            clientId="245618185982-lnl6oreimpc037opfi7o82t69gosbdkg.apps.googleusercontent.com"
            buttonText="Login"
            onSuccess={onSuccess}
            onFailure={(error) => console.error(error)}
            cookiePolicy={'single_host_origin'}
            render={(renderProps) => (
                <button onClick={renderProps.onClick} disabled={renderProps.disabled}>
                    Login with Google
                </button>
            )}
        />
    )
}
